// extracted by mini-css-extract-plugin
export default {"top":"BlogPage_top__3HH0f","container":"BlogPage_container__njxE6"};